import { render } from "./inputNumber.vue?vue&type=template&id=488b8d49&scoped=true&ts=true"
import script from "./inputNumber.vue?vue&type=script&lang=ts"
export * from "./inputNumber.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488b8d49"]])

export default __exports__